import { catalogApi } from '../_api';
import { modelInitialState, catalogInitialState } from '../_utils';
import { servicesEnum } from '../_types';

const CODE = 'related';

export default {
  props: {
    items: { type: Array, required: true, default: () => [] },
  },
  data: () => ({
    model: modelInitialState(),
    localCatalog: catalogInitialState(),
  }),
  computed: {
    alreadyAddedServicesIds() {
      return this.items.map((x) => x?.service.id) || [];
    },
    catalog() {
      return {
        ...this.localCatalog,
        services:
          this.localCatalog.services?.filter(
            ({ id }) =>
              !this.alreadyAddedServicesIds.includes(id) ||
              id === servicesEnum.Otros
          ) || [],
      };
    },
  },
  async created() {
    const [services, modalities, frequencies, durations] = await Promise.all([
      catalogApi.services(CODE),
      catalogApi.modalities(CODE),
      catalogApi.frequencies(),
      catalogApi.durations(CODE),
    ]);

    this.localCatalog = {
      ...this.localCatalog,
      services,
      modalities,
      frequencies,
      durations,
    };
  },
};
